export default __webpack_public_path__ + "static/media/elan-col.af23b677.png";